// ÐÐ¾Ð½ÑÐ°ÐºÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð´Ð»Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ ÐÐÐ Ð½Ð° ÑÐ°Ð³Ðµ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ð¹.
//
// Ð¡ÑÑÐ°Ð½Ð¸ÑÐ° ÑÐ´ÐµÐ»ÐºÐ¸ Ð´ÐµÑÐ¶Ð¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð² Ð¿Ð°Ð¼ÑÑÐ¸ Ñ Ð¼Ð¾Ð¼ÐµÐ½ÑÐ° Ð¾ÑÐºÑÑÑÐ¸Ñ. ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¼ÐµÐ½ÑÐµÑ
// ÑÐµÐ»ÐµÑÐ¾Ð½ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð² Ð´ÑÑÐ³Ð¾Ð¹ Ð²ÐºÐ»Ð°Ð´ÐºÐµ, Ð° ÑÐ´ÐµÐ»ÐºÐ° Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð°ÐµÑ Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÑÑ
// ÑÑÐ°ÑÑÐ¹ Ð½Ð¾Ð¼ÐµÑ Ð² Ð¿ÑÐ¾Ð²ÐµÑÐºÑ Ð¸ Ð¿Ð¾Ð»ÑÑÐ°ÐµÑ Ð¾ÑÐºÐ°Ð· (ÑÐ´ÐµÐ»ÐºÐ° 191883: Ð½Ð¾Ð²ÑÐ¹ Ð½Ð¾Ð¼ÐµÑ Ð¿ÑÐ¾ÑÑÐ»
// Ð¿ÑÐ¾Ð²ÐµÑÐºÑ Ð² 15:12:08, Ð° ÑÐ°Ð³ 4 ÐµÑÑ ÑÑÐ¸ ÑÐ°Ð·Ð° Ð¿ÑÐ¾Ð²ÐµÑÑÐ» ÑÑÐ°ÑÑÐ¹). ÐÐ¾ÑÑÐ¾Ð¼Ñ Ð¿ÐµÑÐµÐ´
// Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¾Ð¹ Ð¿ÐµÑÐµÑÐ¸ÑÑÐ²Ð°ÐµÐ¼ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ñ ÑÐµÑÐ²ÐµÑÐ°, Ð° Ð¿Ð°Ð¼ÑÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ â Ð·Ð°Ð¿Ð°ÑÐ½Ð¾Ð¹ Ð¿ÑÑÑ.

// Ð¡ÐµÑÐ²Ð¸Ñ ÐÐÐ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð» (500/ÑÐ°Ð¹Ð¼Ð°ÑÑ Ð½Ð° Ð½Ð°ÑÐµÐ¼ Ð±ÑÐºÐµÐ½Ð´Ðµ): Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½ÑÐ¶ÐµÐ½ Ð¿Ð¾Ð½ÑÑÐ½ÑÐ¹
// ÑÐµÐºÑÑ Ð¸ ÑÐ¾Ð²ÐµÑ, ÑÑÐ¾ Ð´ÐµÐ»Ð°ÑÑ, Ð° Ð½Ðµ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ° Â«ÐÐ¾Ð´ÑÐ¾Ð±Ð½Ð¾ÑÑÐ¸ Ð´Ð»Ñ ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÑÐ¸ÐºÐ°Â».
export const BMG_UNAVAILABLE_MESSAGE =
  'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ Ð½Ð¾Ð¼ÐµÑ Ð² ÐÐ°Ð·Ðµ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½: ÑÐµÑÐ²Ð¸Ñ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð». ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ ÐµÑÑ ÑÐ°Ð· ÑÐµÑÐµÐ· Ð¼Ð¸Ð½ÑÑÑ, ÐµÑÐ»Ð¸ Ð¾ÑÐ¸Ð±ÐºÐ° Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑÑ â ÑÐ¾Ð¾Ð±ÑÐ¸ÑÐµ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑ.';

export const BMG_PHONE_MISMATCH_MESSAGE =
  'ÐÐ»Ð¸ÐµÐ½Ñ Ñ ÑÑÐ¸Ð¼ ÐÐÐ Ð½Ðµ ÑÐ²Ð»ÑÐµÑÑÑ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐµÐ¼ Ð²Ð²ÐµÐ´ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð½Ð¾Ð¼ÐµÑÐ° ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð¸ Ð½Ðµ Ð¿ÑÐ¾ÑÐ¾Ð´Ð¸Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ ÐÐ°Ð·Ñ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½. ÐÐ¾Ð¿ÑÐ¾ÑÐ¸ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð¸ÑÑ Ð´ÑÑÐ³Ð¾Ð¹ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð°, Ð»Ð¸Ð±Ð¾ Ð¿ÑÐµÐ´Ð»Ð¾Ð¶Ð¸ÑÐµ ÐµÐ¼Ñ Ð¿Ð¾Ð¼ÐµÐ½ÑÑÑ ÑÐ²Ð¾Ð¹ Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° Ð² ÐÐ°Ð·Ðµ ÐÐ¾Ð±Ð¸Ð»ÑÐ½ÑÑ ÐÑÐ°Ð¶Ð´Ð°Ð½.';

const clean = (value) => (value === null || value === undefined ? '' : String(value).trim());

/**
 * Ð¢ÐµÐ»ÐµÑÐ¾Ð½ Ð¸ ÐÐÐ Ð´Ð»Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸: Ð¸Ð· ÑÐ²ÐµÐ¶ÐµÐ¹ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸, ÐµÑÐ»Ð¸ Ð¾Ð½Ð° ÐµÑÑÑ Ð¸ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð°,
 * Ð¸Ð½Ð°ÑÐµ Ð¸Ð· ÑÐ¾Ð³Ð¾, ÑÑÐ¾ Ð»ÐµÐ¶Ð¸Ñ Ð² ÑÐ´ÐµÐ»ÐºÐµ.
 */
export const pickClientContact = (freshClient, dealClient) => {
  const phone = clean(freshClient?.phone) || clean(dealClient?.phone);
  const iin = clean(freshClient?.iin) || clean(dealClient?.iin);
  return { phone, iin };
};

/** Ð¡Ð²ÐµÐ¶Ð°Ñ ÐºÐ°ÑÑÐ¾ÑÐºÐ° ÐºÐ»Ð¸ÐµÐ½ÑÐ°; Ð¿ÑÐ¸ Ð»ÑÐ±Ð¾Ð¹ Ð¾ÑÐ¸Ð±ÐºÐµ â null, Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð¿Ð¾Ð¹Ð´ÑÑ Ð¿Ð¾ Ð´Ð°Ð½Ð½ÑÐ¼ ÑÐ´ÐµÐ»ÐºÐ¸. */
export const loadFreshClient = async (getClients, clientId) => {
  if (!clientId) return null;
  try {
    const res = await getClients({ id: clientId });
    return res?.data?.users?.[0] || null;
  } catch (e) {
    return null;
  }
};
